import { Component } from 'react';

export default class FormField extends Component {
  constructor(props) {
    super(props);
    this.state = { touched: props.element };
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      this.input.focus();
    }
  }

  handleBlur() {
    this.setState({ touched: true });
  }

  render() {
    let className = `minimal-field ${this.props.className}`;
    const error = this.props.errors && this.props.errors[this.props.name];
    let label = this.props.label || this.props.name;

    if (error) {
      className += ' error';
      label += ' ' + error;
    }

    let input;
    let id = this.props.name + '-field';
    if (!this.props.element) {
      input = (
        <input
          className="minimal-text-input modified-text-input"
          onChange={this.props.onChange}
          onBlur={this.handleBlur.bind(this)}
          value={this.props.value || ''}
          placeholder={this.props.placeholder || ''}
          type={this.props.type || 'text'}
          id={id}
          ref={(input) => (this.input = input)}
          name={this.props.name}
        />
      );
    } else {
      input = this.props.children;
    }

    return (
      <div className={className}>
        {input}
        <label htmlFor={id} className="minimal-label">
          {label}
        </label>
      </div>
    );
  }
}
